import React from "react";
import { PropTypes } from "prop-types";
import * as ProductFamilies from "../../../constants/productFamilies";

const ProductInfo = (props) => {
  const hasTitle = props.title !== undefined && props.title !== "";
  const IsRWA03 = props.isrwa03?true:false;
 const isHPI=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="HPI";
 const isInsight=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="INSIGHT";
 const isEscape=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="ESCAPE";
 const isWWT=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="WWT";
 const isDELL=props.PartnerURLVal&& props.PartnerURLVal.toUpperCase()==="DELL";
 const VgpuTitle="Start your 90-day vGPU trial";
 const OmniverseTitle="Start your 30-day Omniverse Enterprise trial";
 let title="";
 const PartnerOmniverseTitle="Start your 90-day Partner Omniverse Enterprise trial";
 const NvaieTitle="Start your 90-day AI Enterprise trial";
 if (isHPI) {
  title ="Hello HP customer, welcome to the Omniverse Enterprise 90 day trial."
} else if(isInsight) {
  title ="Hello Insight customer, welcome to the Omniverse Enterprise 90 day trial."
}
else if(isEscape)
{
  title ="Hello Escape Technology customer, welcome to the Omniverse Enterprise 90 day trial."
}
else if(isWWT)
{
  title ="Hello WWT customer, welcome to the Omniverse Enterprise 90 day trial."
}
else{
title="Start your 90-day Partner Omniverse Enterprise trial";
}

  if (IsRWA03 &&
   props.productfamily.toUpperCase()===ProductFamilies.vgpu
    ) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
          { <h3>{VgpuTitle}</h3>}
          <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            <li>NVIDIA virtual GPU solutions are designed to run on NVIDIA® GPUs. Please ensure you have the following before downloading the NVIDIA virtual GPU software evaluation edition:
              
               </li>
               <ul>
                    <li>NVIDIA Virtual GPU Certified Servers.<a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/resources/vgpu-certified-servers/'
              >
                {" "}
                See a complete list of certified systems.{" "}
              </a>{" "}</li>
              <li>
                <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/graphics-cards-for-virtualization/'
              >
                {" "}
                Supported NVIDIA GPUs:{" "}
              </a>{" "} NVIDIA A10, A16, A30, A40, A100, T4, RTX 8000, RTX 6000, V100S, V100, P100, P40, P6, P4, M60, M10</li>
              <li>
            Virtualization Software from VMware, Citrix, Red Hat, and Nutanix.
            </li>
               </ul>
           
            <li>
              {" "}
              If you don’t have NVIDIA GPUs, but would like to purchase, please <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>
            </li>
            
          </ul>
          
        </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.Partneromniverse) {
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>

        { <h3>{title}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
           
            
  
  <li>Please ensure the following requirements are met:
              <ul>
                <li>
                Minimum GPU requirements are RTX-enabled GPUs with 6GB VRAM
                </li>
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM
                </li>
              </ul>
              </li>
              
        
              <li>
              For information about supported hardware and software, refer to the system requirements per app or platform 
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.omniverse.nvidia.com/plat_omniverse/plat_omniverse/technical.html'
              >
                {" "}
                here{" "}
              </a>{" "}
                </li>
         
            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/nvidia-omniverse-partner-faq/'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              .
            </li>
          </ul>
        </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.omniverse) {
    return (
      <div className={"infoBlock"}>
        
        <div className={"infoBlockEval"}>
         
         { <h3>{OmniverseTitle}</h3>} 
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
            {isDELL && 
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM.
                </li>
               
            }
            {!isDELL && 
            <li>Please ensure the following requirements are met:
              <ul>
                <li>
                Minimum GPU requirements are RTX-enabled GPUs with 6GB VRAM
                </li>
                <li>
                Recommended GPU requirements are RTX-enabled GPUs with 8GB VRAM
                </li>
              </ul>
              </li>
  }
              <li>
              For information about supported hardware and software, refer to the system requirements per app or platform 
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://docs.omniverse.nvidia.com/plat_omniverse/plat_omniverse/technical.html'
              >
                {" "}
                here{" "}
              </a>{" "}
                </li>
  


            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/omniverse/enterprise/free-trial/#faqs'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              .
            </li>
          </ul>
        </div>
      </div>
    );
  }
  else if(IsRWA03 && props.productfamily.toUpperCase()===ProductFamilies.nvaie) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
        { <h3>{NvaieTitle}</h3>}
        <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            
            <li>
              Please ensure that the person who is registering for the
              evaluation licenses is the person who will be managing those
              licenses.
            </li>
            <li>
              {" "}
              If already registered, click <a href={props.idmlogin}>here</a>
            </li>
            <li>
              If you need assistance with registration or are seeking an
              exception, please review{" "}
              <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/nvidia-enterprise-account-faq/'
              >
                {" "}
                FAQ{" "}
              </a>{" "}
              
            </li>
          </ul>
          </div>
      </div>
    );
  }
  else if(IsRWA03 ) {
    return (
      <div className={"infoBlock"}>
        <div className={"infoBlockEval"}>
          { <h3>{VgpuTitle}</h3>}
          <h4>
            <b>IMPORTANT TIPS </b>
          </h4>
          <ul>
            <li>Please register with your corporate email address.</li>
            <li>
              Personal email addresses or extensions will not be approved.
            </li>
            <li>NVIDIA virtual GPU solutions are designed to run on NVIDIA® GPUs. Please ensure you have the following before downloading the NVIDIA virtual GPU software evaluation edition:
              
               </li>
               <ul>
                    <li>NVIDIA Virtual GPU Certified Servers.<a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/resources/vgpu-certified-servers/'
              >
                {" "}
                See a complete list of certified systems.{" "}
              </a>{" "}</li>
              <li>
                <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/data-center/graphics-cards-for-virtualization/'
              >
                {" "}
                Supported NVIDIA GPUs:{" "}
              </a>{" "} NVIDIA A10, A16, A30, A40, A100, T4, RTX 8000, RTX 6000, V100S, V100, P100, P40, P6, P4, M60, M10</li>
              <li>
            Virtualization Software from VMware, Citrix, Red Hat, and Nutanix.
            </li>
               </ul>
           
            <li>
              {" "}
              If you don’t have NVIDIA GPUs, but would like to purchase, please <a
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.nvidia.com/en-us/contact/sales/'
              >
                {" "}
                contact us.{" "}
              </a>
            </li>
            
          </ul>
          
        </div>
      </div>
    );
  }
  
};


ProductInfo.propTypes = {
  PartnerURLVal: PropTypes.string,
  title: PropTypes.string,
  isrwa03: PropTypes.number.isRequired,
   productfamily: PropTypes.string.isRequired,
   link: PropTypes.string.isRequired,
   linktext: PropTypes.string.isRequired,
   idmlogin: PropTypes.string.isRequired,
};

export default ProductInfo;
